<script setup>
defineProps({
  targetId: {
    type: String,
    required: true,
  },
  options: {
    type: Array,
    default: () => [],
  },
  widthClass: {
    type: String,
    default: 'w-36',
  },
  alignClass: {
    type: String,
    default: 'left-0',
  },
  paddingClass: {
    type: String,
    default: 'p-1',
  },
  itemPaddingClass: {
    type: String,
    default: 'px-2 py-1.5',
  },
  itemIconClass: {
    type: String,
    default: 'text-[12px]',
  },
});

const emit = defineEmits(['select']);

defineOptions({
  inheritAttrs: false,
});
</script>

<template>
  <div
    :data-quick-insert-menu="targetId"
    class="absolute bottom-[calc(100%+0.3rem)] z-20 rounded-[1rem] bg-white shadow-[0_10px_24px_rgba(15,23,42,0.12)] ring-1 ring-black/5"
    :class="[widthClass, alignClass, paddingClass]"
    v-bind="$attrs"
  >
    <button
      v-for="option in options"
      :key="`${targetId}_${option.id}`"
      type="button"
      class="flex w-full items-center gap-2 rounded-[0.8rem] text-right text-[11px] font-medium text-n-slate-12 transition hover:bg-n-slate-2"
      :class="itemPaddingClass"
      @click.stop="emit('select', option.id)"
    >
      <i :class="[itemIconClass, option.icon]" />
      <span class="truncate">{{ option.label }}</span>
    </button>
  </div>
</template>
